import script from "./DisplayTags.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayTags.vue?vue&type=script&setup=true&lang=js"

import "./DisplayTags.vue?vue&type=style&index=0&id=ef6b2864&scoped=true&lang=scss"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef6b2864"]])

export default __exports__